
import { useAddSrpFragmentToLink } from '../composables/srpLink';
import { computed, defineComponent, toRefs } from 'vue';

export default defineComponent({
  name: 'EmhSecondaryButton',
  props: {
    secondaryLink: String,
    secondaryLabel: String,
  },
  emits: ['button-click'],
  setup(props, { emit }) {
    const { secondaryLink } = toRefs(props);
    const { addSrpFragmentToLink } = useAddSrpFragmentToLink();
    const link = computed(() => addSrpFragmentToLink(secondaryLink?.value ?? ''));

    const handleButtonClick = (e: MouseEvent) => emit('button-click', e);

    return {
      link,
      handleButtonClick,
    };
  },
});
